import React from 'react';
import PropTypes from 'prop-types';

import InputInlineEditable from "core/gd-components/input-inline-editable/input-inline-editable";

import Classes from 'classnames';

export default class FilterFormString extends React.Component {

    static propTypes = {
        filter: PropTypes.object.isRequired,         // link to filter instance
    };

    componentDidMount() {
        this.input.focus();
    }

    onChange = (value) => {
        const curValue = this.props.filter.getValue()
        if (value !== curValue) {
            this.props.filter.setValue(value, false)
            this.setState({reRender: true})
        }
    }

    render() {
        const curValue = this.props.filter.getValue();

        return (
            <div className="block-content filter-multiselect">
                <div className={Classes("type-option no-checkbox")} >
                    <div className="name">Contains</div>
                    <InputInlineEditable ref={r=>this.input = r} type="text" className="size-30 string" value={curValue} formSize={30} onChange={this.onChange} />
                    <div className="cf"/>
                </div>
            </div>
        );
    }
}